import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// attach JWT if present
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('trj_access_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const ASSETS = {
  // Bundled with the production build so the site never depends on a remote
  // asset host (eliminates inconsistent loading across devices/networks).
  // The shield is now a transparent-background PNG so it sits cleanly on
  // any navy/dark background without the white box.
  hero: '/brand/hero.png',
  shield: '/brand/shield.png',
  student: 'https://images.unsplash.com/photo-1507208773393-40d9fc670acf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBzdHVkeWluZyUyMGxhcHRvcHxlbnwwfHx8fDE3ODEyMjc0OTd8MA&ixlib=rb-4.1.0&q=85',
  graduation: 'https://images.unsplash.com/photo-1623461487986-9400110de28e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxncmFkdWF0aW9uJTIwYnVzaW5lc3N8ZW58MHx8fHwxNzgxMjI3NDk3fDA&ixlib=rb-4.1.0&q=85',
  seminar: 'https://images.unsplash.com/photo-1574884280706-7342ca3d4231?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBhY2NvdW50aW5nJTIwc2VtaW5hcnxlbnwwfHx8fDE3ODEyMjc0OTd8MA&ixlib=rb-4.1.0&q=85',
};

export const SCHOOLS = [
  { slug: 'school-of-taxation', name: 'School of Taxation', tagline: 'Foundational & advanced taxation programs.', icon: 'Scale' },
  { slug: 'school-of-accounting', name: 'School of Accounting & Bookkeeping', tagline: 'Bookkeeping, accounting, and payroll certifications.', icon: 'BookOpen' },
  { slug: 'school-of-business', name: 'School of Business Development', tagline: 'Launch, grow, and operate a professional practice.', icon: 'Briefcase' },
  { slug: 'continuing-education', name: 'Continuing Education Center', tagline: 'Annual federal tax refreshers, ethics, and CE.', icon: 'GraduationCap' },
  { slug: 'ea-success', name: 'EA Success Center', tagline: 'Enrolled Agent exam preparation and tutoring.', icon: 'Award' },
];

export const SCHOOL_NAME_BY_SLUG = {
  'school-of-taxation': 'School of Taxation',
  'school-of-accounting': 'School of Accounting & Bookkeeping',
  'school-of-business': 'School of Business Development',
  'continuing-education': 'Continuing Education Center',
  'ea-success': 'EA Success Center',
};
